module.exports = __webpack_public_path__ + "img/8_10.f6adab09.png";